/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PatchConsigneeSelfCheckinRequest } from '../../models/patch-consignee-self-checkin-request';

export interface PatchConsigneeSelfCheckinV3$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
      body: PatchConsigneeSelfCheckinRequest
}

export function patchConsigneeSelfCheckinV3(http: HttpClient, rootUrl: string, params: PatchConsigneeSelfCheckinV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchConsigneeSelfCheckinV3.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchConsigneeSelfCheckinV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/consignee-signature';
